import React from 'react';
import {
  Filter as FilterAdmin,
  TextInput,
  ReferenceInput,
  AutocompleteInput,
} from 'react-admin';

const Filter = (props) => (
  <FilterAdmin {...props}>
    <TextInput label="Descrição" source="nome" />
    <ReferenceInput
      fullWidth
      label="Equipe"
      source="equipe_colaborador_id"
      reference="equipes_colaborador"
      sort={{ field: 'nome', order: 'ASC' }}
      filterToQuery={(searchText) => ({ nome: `${searchText}` })}
      perPage={30}
    >
      <AutocompleteInput optionText="nome" />
    </ReferenceInput>
  </FilterAdmin>
);

export default Filter;
